/**
 * Tenant Service
 * API calls for tenant-level operations and settings
 */

import api from '@services/api';

export interface ConversationType {
  type: string;
  name: string;
  description: string;
  supports_model_switching: boolean;
  supports_file_attachments: boolean;
  supports_system_prompts: boolean;
  allowed_models: string | string[];
  required_config?: string[];
}

export interface ConversationTypesResponse {
  conversation_types: ConversationType[];
  tenant_id: string;
}

/**
 * Get conversation types available for current tenant
 */
export const getConversationTypes = async (): Promise<ConversationType[]> => {
  try {
    const response = await api.get<ConversationTypesResponse>('/tenants/conversation-types');
    return response.data.conversation_types;
  } catch (error) {
    console.error('[tenantService] Failed to get conversation types:', error);
    throw error;
  }
};

/**
 * Get tenant settings
 */
export const getTenantSettings = async (): Promise<any> => {
  try {
    const response = await api.get('/tenants/current/settings');
    return response.data;
  } catch (error) {
    console.error('[tenantService] Failed to get tenant settings:', error);
    throw error;
  }
};

/**
 * Update tenant settings
 */
export const updateTenantSettings = async (settings: any): Promise<any> => {
  try {
    const response = await api.put('/tenants/current/settings', settings);
    return response.data;
  } catch (error) {
    console.error('[tenantService] Failed to update tenant settings:', error);
    throw error;
  }
};

const tenantService = {
  getConversationTypes,
  getTenantSettings,
  updateTenantSettings,
};

export default tenantService;
